import { appOspSecurity } from "@api/osp";
import { isEmpty } from "lodash-es";
import { useEffect, useState } from "react";

export function useRequestHeader() {
  const [headers, setHeader] = useState<Record<string, string>>({});
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const init = async () => {
      try {
        const header = await appOspSecurity.getRequestHeader();
        if (!isEmpty(header)) {
          setHeader(header);
        }
      } finally {
        setIsReady(true);
      }
    };
    void init();
  }, []);

  return {
    headers,
    isReady,
  };
}
